var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.44 4.71416C9.4043 4.6221 9.35078 4.53799 9.2825 4.46666L5.5325 0.716663C5.46257 0.646734 5.37955 0.591263 5.28819 0.553418C5.19682 0.515573 5.09889 0.496094 5 0.496094C4.80027 0.496094 4.60873 0.575435 4.4675 0.716663C4.39757 0.786591 4.3421 0.869609 4.30426 0.960976C4.26641 1.05234 4.24693 1.15027 4.24693 1.24916C4.24693 1.44889 4.32627 1.64043 4.4675 1.78166L6.9425 4.24916H1.25C1.05109 4.24916 0.860322 4.32818 0.71967 4.46883C0.579018 4.60948 0.5 4.80025 0.5 4.99916C0.5 5.19807 0.579018 5.38884 0.71967 5.52949C0.860322 5.67014 1.05109 5.74916 1.25 5.74916H6.9425L4.4675 8.21666C4.3972 8.28638 4.34141 8.36933 4.30333 8.46073C4.26526 8.55212 4.24565 8.65015 4.24565 8.74916C4.24565 8.84817 4.26526 8.9462 4.30333 9.03759C4.34141 9.12899 4.3972 9.21194 4.4675 9.28166C4.53722 9.35196 4.62017 9.40775 4.71157 9.44583C4.80296 9.48391 4.90099 9.50351 5 9.50351C5.09901 9.50351 5.19704 9.48391 5.28843 9.44583C5.37983 9.40775 5.46278 9.35196 5.5325 9.28166L9.2825 5.53166C9.35078 5.46033 9.4043 5.37623 9.44 5.28416C9.51501 5.10157 9.51501 4.89676 9.44 4.71416Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.ee45dab9fa7c39ef1682a6f882acf7e6.svg";
export { ForwardRef as ReactComponent };